import { usePublicCollectionItemStatus } from "@/composables/collectionItem/public/publicCollectionItemStatus";
import { useUser } from "@/composables/user/user";
import { redirectToAuth } from "@/router/helpers";
import { createMarketplaceItemLink, createPublicItemDetailLink } from "@/router/linkFactories";
import { fetchPublicCollectionItemById } from "@/services/collection/item/public/publicCollectionItemApi";
import { PublicItemNotFoundException } from "@/services/collection/item/public/publicCollectionItemTypes";
import { checkUserOnInitialPageLoad } from "@/services/user/auth/login/helpers";
import { toRef } from "vue";
import { type NavigationGuardNext, type RouteLocationNormalized } from "vue-router";

export const handleItemEditationAccess = async (toRoute: RouteLocationNormalized, _from: RouteLocationNormalized, next: NavigationGuardNext) => {
  await checkUserOnInitialPageLoad();
  const { isUserLoggedIn } = useUser();
  if (isUserLoggedIn.value) {
    return next();
  }

  const itemId = parseInt(toRoute.params.id as string);
  return fetchPublicCollectionItemById(itemId)
    .then((item) => {
      // Item is public - let's redirect to Public item detail or to Marketplace item detail
      const { marketplaceItem } = usePublicCollectionItemStatus(toRef(item));
      if (marketplaceItem.value !== undefined) {
        const marketplaceItemDetailRoute = createMarketplaceItemLink(marketplaceItem.value.id, marketplaceItem.value.name);
        return next(marketplaceItemDetailRoute);
      } else {
        const publicItemDetailRoute = createPublicItemDetailLink(item.id, item.name, item.collectorNickname);
        return next(publicItemDetailRoute);
      }
    })
    .catch((e: unknown) => {
      if (e instanceof PublicItemNotFoundException) {
        // Item not public - redirect to login
        return redirectToAuth(toRoute, next);
      } else {
        throw e;
      }
    });
};
